import React, { useEffect, useState } from 'react'
import { Box, Button, Checkbox, Group, LoadingOverlay, Modal, Paper, SimpleGrid, Switch, Table, Text, Image } from '@mantine/core'
import { useSelector } from 'react-redux'
import { editProduct } from '../../../../services/products'
import { notificationError, notificationSuccess } from '../../../ui/Notifications'
import FormBundlePrice from './Form/FormBundlePrice'
import FormWholesalePrice from './Form/FormWholesalePrice'
import { modals } from '@mantine/modals'
import SearchMascot from '../../../../assets/img/mascot/18.png'


const ProductWholesaleAndBundle = ({ productId, reloadProduct }) => {
  const { isLoadingProduct, summary, prices, minimumPayload, variants } = useSelector(state => state.product_detail)

  const [enablePricing, setEnablePricing] = useState(false)

  const [isBundlePrices, setIsBundlePrices] = useState(false)
  const [modalBundlePrice, setModalBundlePrice] = useState(false)

  const [isWholeSalePrices, setIsWholeSalePrices] = useState(false)
  const [modalWholesalePrice, setModalWholesalePrice] = useState(false)

  const [isExclusive, setIsExclusive] = useState(false)

  // service
  const [loadingSubmit, setLoadingSubmit] = useState(false)

  const handleDisableVariant = () => {
    handleSubmit({ skus: [], attributes: [] })
  }

  const handleDisableBundlePrice = () => {
    handleSubmit({ pricing_type: 'wholesalePrice' })
  }

  const showConflictResolutionModal = () => {
    modals.open({
      title: <Text fw={700}>Conflict Detected</Text>,
      centered: true,
      size: 'lg',
      withCloseButton: false,
      children: (
        <Box>
          <Box ta='center'>
            <Image src={SearchMascot} fit='contain' h='180' my={20} />
            <Text fw={500} mb={4}>Conflict Detected!</Text>
            <Text fz='sm' c='gray.6' mb={20}>
              Bundle Price and Product Variants cannot be enabled at the same time.
              Which one would you like to disable?
            </Text>
          </Box>
          <Group grow mt="xl">
            <Button color="red" onClick={() => { handleDisableVariant(); modals.closeAll() }}>
              Disable Product Variant
            </Button>
            <Button color="blue" variant="outline" onClick={() => { handleDisableBundlePrice(); modals.closeAll() }}>
              Disable Bundle Price
            </Button>
          </Group>
        </Box>
      ),
    })
  }

  const checkPricingType = () => {
    setEnablePricing(prices.enablePricing)
    setIsExclusive(prices.isExclusive)
    if (prices.pricingType === 'bulkPrice') {
      setIsBundlePrices(true)
      if (variants && variants.structure && variants.structure.length > 0) {
        showConflictResolutionModal()
      }
    } else if (prices.pricingType === 'wholesalePrice') {
      setIsWholeSalePrices(true)
    }
  }

  useEffect(() => {
    if (!isLoadingProduct && summary) {
      checkPricingType()
    }
    // eslint-disable-next-line
  }, [isLoadingProduct, prices, variants])


  // service
  const generatePayload = () => {
    return {
      ...minimumPayload,
      enable_pricing: enablePricing,
      is_exclusive: isExclusive,
      pricing_type: isWholeSalePrices ? 'wholesalePrice' : isBundlePrices ? 'bulkPrice' : ''
    }
  }

  const handleSubmit = async (payload) => {
    console.log(payload)
    try {
      setLoadingSubmit(true)
      const minimumPayload = generatePayload()
      const response = await editProduct(productId, { ...minimumPayload, ...payload })
      if (response.success) {
        setModalBundlePrice(false)
        setModalWholesalePrice(false)
        notificationSuccess('Success', 'Update Product Success')
        reloadProduct()
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Product Error', `${errorMessage ? errorMessage : 'Please contact your administrator'}`)
    } finally {
      setLoadingSubmit(false)
    }
  }

  const renderButtonUpdate = () => {
    const buttonStyle = {
      position: 'fixed',
      bottom: '25px',
      right: '55px',
      padding: '10px',
      zIndex: 1000,
    }
    return (
      <Button
        size='sm'
        style={buttonStyle}
        loading={loadingSubmit}
        loaderProps={{ type: 'dots' }}
        onClick={() => handleSubmit()}
      >
        Update
      </Button>
    )
  }

  const renderPrices = () => {
    const wholesalePriceRows = prices.wholesalePrices.map((element, index) => (
      <Table.Tr key={index}>
        <Table.Td>{element.min_quantity}</Table.Td>
        <Table.Td>{element.price}</Table.Td>
      </Table.Tr>
    ))
    const bundlePriceRows = prices.bundlePrices.map((element, index) => (
      <Table.Tr key={index}>
        <Table.Td>{element.unit_name}</Table.Td>
        <Table.Td>{element.quantity}</Table.Td>
        <Table.Td>{element.price}</Table.Td>
        <Table.Td>{element.dimensions[0].value} {element.dimension_unit}</Table.Td>
        <Table.Td>{element.dimensions[1].value} {element.dimension_unit}</Table.Td>
        <Table.Td>{element.dimensions[2].value} {element.dimension_unit}</Table.Td>
        <Table.Td>{element.weight} {element.weight_unit}</Table.Td>
      </Table.Tr>
    ))

    return (
      <SimpleGrid cols={2}>
        {/** Wholesale Price */}
        <Paper my={'md'} p={'md'} withBorder shadow="xs" radius="md">
          <Box>
            <Group justify="space-between" gap="sm">
              <Text fw={500}>Wholesale Price</Text>
              <Button disabled={!isWholeSalePrices} size='xs' variant="default" onClick={() => setModalWholesalePrice(true)}>Add and Modify</Button>
            </Group>
            <Group gap="sm" mt={'sm'}>
              <Paper shadow="sm" radius="sm" withBorder p='xs'>
                <Checkbox
                  size="xs"
                  label="Enable Wholesale Price"
                  checked={isWholeSalePrices}
                  onChange={(event) => {
                    setIsWholeSalePrices(event.currentTarget.checked)
                    // setIsBundlePrices(!event.currentTarget.checked)
                  }}
                />
              </Paper>
              {
                isWholeSalePrices &&
                <Paper shadow="xs" radius="sm" withBorder p='xs'>
                  <Checkbox
                    size="xs"
                    label="Exclusive Wholesale (Order per Pcs didn't Allowed)"
                    checked={isExclusive}
                    onChange={(event) => setIsExclusive(event.currentTarget.checked)}
                  />
                </Paper>
              }
            </Group>
            <Box pos='relative' h={'full'}>
              <Table mt={'sm'} highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
                <Table.Thead style={{ backgroundColor: '#eeefef' }}>
                  <Table.Tr>
                    <Table.Th>Min Order Quantity</Table.Th>
                    <Table.Th>Wholesale Price ({summary.originalCurrency})</Table.Th>
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody style={{ verticalAlign: 'top' }}>{wholesalePriceRows}</Table.Tbody>
              </Table>
              <LoadingOverlay visible={!isWholeSalePrices} overlayProps={{ radius: 'sm', blur: 2 }} loaderProps={{ children: 'Disabled' }} />
            </Box>
          </Box>
        </Paper>

        {/** Bundle Price */}
        <Paper my={'md'} p={'md'} withBorder shadow="xs" radius="md">
          <Box>
            <Group justify="space-between" gap="sm">
              <Text fw={500}>Bundle Price</Text>
              <Button disabled={!isBundlePrices} size='xs' variant="default" onClick={() => setModalBundlePrice(true)}>Add and Modify</Button>
            </Group>
            <Group gap="sm" mt={'sm'}>
              <Paper shadow="sm" radius="sm" withBorder p='xs'>
                <Checkbox
                  size="xs"
                  label="Enable Bundle Price"
                  checked={isBundlePrices}
                  onChange={(event) => {
                    if (event.currentTarget.checked && variants && variants.structure && variants.structure.length > 0) {
                      showConflictResolutionModal()
                      return
                    }
                    setIsBundlePrices(event.currentTarget.checked)
                    setIsWholeSalePrices(!event.currentTarget.checked)
                  }}
                />
              </Paper>
              {
                isBundlePrices &&
                <Paper shadow="sm" radius="sm" withBorder p='xs'>
                  <Checkbox
                    size="xs"
                    label="Exclusive Bundle (Order per Pcs didn't Allowed)"
                    checked={isExclusive}
                    onChange={(event) => setIsExclusive(event.currentTarget.checked)}
                  />
                </Paper>
              }
            </Group>
            <Box pos="relative" h={'full'}>
              <Table mt={'sm'} highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
                <Table.Thead style={{ backgroundColor: '#eeefef' }}>
                  <Table.Tr>
                    <Table.Th>Bundle Unit</Table.Th>
                    <Table.Th>Quantity</Table.Th>
                    <Table.Th>Bundle Price</Table.Th>
                    <Table.Th>Length</Table.Th>
                    <Table.Th>Width</Table.Th>
                    <Table.Th>Height</Table.Th>
                    <Table.Th>Weight</Table.Th>
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody style={{ verticalAlign: 'top' }}>{bundlePriceRows}</Table.Tbody>
              </Table>
              <LoadingOverlay visible={!isBundlePrices} overlayProps={{ radius: 'sm', blur: 2 }} loaderProps={{ children: 'Disabled' }} />
            </Box>
          </Box>
        </Paper>
      </SimpleGrid>
    )
  }

  return (
    <Box mb={20} mt={10}>
      <Box mt={'xl'}>
        {
          !enablePricing &&
          <Text c='dimmed' fw={500} style={{ textAlign: "center" }} mb={'sm'}>You can create custom prices with the Wholesale or Bulk Discount</Text>
        }
        <Group justify="center" gap="xs" grow={enablePricing} >
          <Paper shadow="xs" radius="md" withBorder p='md'>
            <Switch
              checked={enablePricing}
              onChange={(event) => {
                if (event.currentTarget.checked && isBundlePrices && variants && variants.structure && variants.structure.length > 0) {
                  showConflictResolutionModal()
                  return
                }
                setEnablePricing(event.currentTarget.checked)
              }}
              color="teal"
              withThumbIndicator={false}
              label="Show Wholesale and Bundle"
              size="xs"
            />
          </Paper>
        </Group>
      </Box>

      {
        enablePricing &&
        renderPrices()
      }

      {renderButtonUpdate()}

      <Modal size={'70%'} opened={modalBundlePrice} onClose={() => setModalBundlePrice(false)} title="Bundle Price">
        {/* Modal content */}
        <FormBundlePrice loading={loadingSubmit} onCloseForm={() => setModalBundlePrice(false)} onSave={(payload) => handleSubmit(payload)} />
      </Modal>
      <Modal size={'xl'} opened={modalWholesalePrice} onClose={() => setModalWholesalePrice(false)} title="Wholesale Price">
        {/* Modal content */}
        <FormWholesalePrice loading={loadingSubmit} onCloseForm={() => setModalWholesalePrice(false)} onSave={(payload) => handleSubmit(payload)} />
      </Modal>
    </Box>
  )
}

export default ProductWholesaleAndBundle